module.exports = {
      id: "pen-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#pen",
      toString: function () {
        return this.url;
      }
    }